/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobsList {
    getFixupPrototypeFunction() { return TemplateJobsList.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobsList>): TemplateJobsList {
        let obj = Object.assign(new TemplateJobsList(), model);
        TemplateJobsList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobsList>): TemplateJobsList {
        if (!model) return null;
        return TemplateJobsList.newInstance(<TemplateJobsList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobsList) {
        if (!obj) return;

        models.TemplateJobsList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobsList): boolean {
        Object.setPrototypeOf(obj, TemplateJobsList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.incident_reference) {
            models.TemplateIncidentReference.fixupPrototype(this.incident_reference);
        }
    }

    /**
     * Unique ID of the template job.
     */
    id: string;

    /**
     * Name of the template job.
     */
    name: string;

    /**
     * Overall status of the template execution
     */
    status: models.TemplateJobStatus;

    /**
     * Type of the executed template [heat/mistral]
     */
    type: string;

    /**
     * Error message if failed
     */
    status_reason: string;

    /**
     * User who initiated the template execution
     */
    user_name: string;

    /**
     * list of actions supported for this job based on its type.
     */
    job_actions: Array<string>;

    /**
     * Incident reference details.
     */
    incident_reference: models.TemplateIncidentReference;

}
